import React, { type MouseEvent } from 'react';

import CrossIcon from '@atlaskit/icon/core/cross';

import { StyledClearButton } from './styled';

interface ClearButtonProps {
	isSelected: boolean;
	label: string;
	onClick: (e: MouseEvent<HTMLElement>) => Promise<void> | void;
	type: string;
}

export const ClearButton = ({ label, ...props }: ClearButtonProps) => (
	<StyledClearButton {...props} data-testid="paginated-picker.ui.clear-button">
		<CrossIcon color="currentColor" label={label} size="small" />
	</StyledClearButton>
);

ClearButton.defaultProps = {
	isSelected: false,
	type: 'button',
};

export default ClearButton;
